export const authInitialState = {
    token: "",
    isLoggedIn: false, 
    authenticatedUser: ""
}